import Auth from '../Auth'
import axios from 'axios'
import constant from '../../configs/constant'
import jwt_decode from "jwt-decode"
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import history from '../Navigation';
import moment from 'moment';

const URL = constant.serverUrl;

const MySwal = withReactContent(Swal);

const serverCall = async (config) => {
  //header authorization
    // const token = config.acsessType;
    config.headers = {
      'Access-Control-Allow-Origin':'*',
      // "authorization": `Bearer ${token}`,
      "Content-Type":config.contentType,
      "Accept":config.accept
  }
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: 'net work error',
          status: 500
        }
      }
      
      return Promise.reject(error);
    });
  config.baseURL = URL
  return axios(config)
}

const serverCallTech = async (config) => {
  //header authorization
    const token = JSON.parse(localStorage.getItem('auth'));
    config.headers = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": `Bearer ${token}`,
      "Content-Type":config.contentType,
      "Accept":config.accept
  }
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: 'net work error',
          status: 500
        }
      }
      
      return Promise.reject(error);
    });
  config.baseURL = URL
  return axios(config)
}


const serverCallCust = async (config) => {
  //header authorization
    const token = JSON.parse(localStorage.getItem('auth'));
    config.headers = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": `Bearer ${token}`,
      "Content-Type":config.contentType,
      "Accept":config.accept
  }
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: 'net work error',
          status: 500
        }
      }
      return Promise.reject(error);
    });
  config.baseURL = URL
  return axios(config)
}

const serverCallWork = async (config) => {
  //header authorization
    const token = JSON.parse(localStorage.getItem('auth'));
    config.headers = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": `Bearer ${token}`,
      "Content-Type":config.contentType,
      "Accept":config.accept
  }
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: 'net work error',
          status: 500
        }
      }
      return Promise.reject(error);
    });
  config.baseURL = URL
  return axios(config)
}

const serverCallOther = async (config) => {
  //header authorization
    const token = JSON.parse(localStorage.getItem('auth'));
    config.headers = {
      // 'Access-Control-Allow-Origin':'*',
      "Authorization": `Bearer ${token}`,
      "Content-Type":config.contentType,
      "Accept":config.accept
  }
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if(error.response.status===401){
        Auth.logout()
        throw error
      }
      return Promise.reject(error);
    });
  config.baseURL = URL
  return axios(config)
}
// export default serverCall

export const Getlogin = (bodyData) => {
  var bodyDataMain = {
      username:bodyData.username,
      password:bodyData.password,
      scope:bodyData.scope
  };
  var formBody = [];
  for (var submitData in bodyDataMain) {
    var encodedKey = encodeURIComponent(submitData);
    var encodedValue = encodeURIComponent(bodyData[submitData]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&");
  return serverCall({
    method: 'POST',
    url: 'login/',
    data: formBody,
    accept:'application/json',
    contentType:'application/x-www-form-urlencoded;charset=UTF-8'
  })
    .then(res => {
      if(res.status === 200){
        var tokendata = res.data.access_token;
        localStorage.setItem('auth', JSON.stringify(res.data.access_token));
        // sessionStorage.setItem('authpost', JSON.stringify(res.data.access_token));
        // Auth.setUserToken(res.data.access_token);
        var decoded = jwt_decode(res.data.access_token);
        var userpermisson = decoded.user_permissions;
        var userpermissonData = [];
        var currentData = new Date();
        for (var i = 0; i < userpermisson.length; i++) {
            var ApplicationPermissions = userpermisson[i].ApplicationPermissions;
            for (var j = 0; j < ApplicationPermissions.length; j++) {
              var userpermissonMain = {};
              userpermissonMain.ApplicationCode = userpermisson[i].ApplicationCode; 
              userpermissonMain.ApplicationPermissionValue = ApplicationPermissions[j].ApplicationPermissionValue;
              userpermissonMain.PermissionCode = ApplicationPermissions[j].PermissionCode;
              userpermissonData.push(userpermissonMain);
            }
        }
        var accsessData = {
          'accesstoken':res.data.access_token,
          'userdata':decoded,
          'tokendata':currentData,
          'appver':constant.appVersions,
          'userpermisson':userpermisson,
        };
        if(userpermissonData[0].PermissionCode === "COMPLETE_JOB"){
          var sendData = {
            techId:decoded.user_id
          }
          // getSiteId(tokendata,decoded.user_id);
          // getTypeofWork(tokendata,bodyData.username);
          // getProfile(decoded.user_id)
          // getNotification(sendData)
          // JumpTo('/');
           setInterval(function () {
            window.location.href = "/new-job";
          }, 1000);
        }else{
          window.location.href = "/pm-schedule";
        }

        localStorage.setItem('access_token',JSON.stringify(accsessData));
        localStorage.setItem('permissions',JSON.stringify(userpermissonData));
        // window.location.href = constant.serverUrl+"create-job";
        return true;
        
      }else{
        MySwal.fire('<p>Incorrect username or password, please try again!<p>');
        return 1;
      }
    }).catch((err) => {
      const condition = navigator.onLine ? 'online' : 'offline';
      console.log('err',err);
      if(condition === 'offline'){
        MySwal.fire('<p>You are currently offline. Please connect to internet and try again!<p>');
        return 1;
      }else{
        MySwal.fire('<p>Incorrect username or password, please try again!<p>');
        console.log(err.message);
        return 1;
      }
    });
}

export const getBackSiteid = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'users/'+bodyData.userid+'/sites/',
    accept:'application/json',
    contentType:'application/json',
    acsessType:bodyData
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackFullSite = ()=>{
  return serverCallOther({
    method: 'GET',
    url: 'sites/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMappingArea = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/area/'+bodyData.siteId+'/areamapping/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMappingEquipments = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/equipments/'+bodyData.equipmentId+'/eqptmapping/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMappingComponent = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/components/'+bodyData.componentId+'/compmapping/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMappingTaskList = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/components/'+bodyData.componentId+'/taskmapping/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMasterArea = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'sites/'+bodyData.siteId+'/areas/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMasterComponent = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/equipments/'+bodyData.equipmentId+'/componentsummary/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackMasterEquipment = ()=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/equipments/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackEditComponent = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/components/'+bodyData.componentsID+'/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackSelectionType = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: '/common/selections/?selection_type='+bodyData.selectionType,
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackTaskListAll = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/components/'+bodyData.componentId+'/taskmapping/'+bodyData.EquipmentComponentID+'/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackJobsData = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/jobs/summary/?site_id='+bodyData.site_id+'&area_id='+bodyData.area_id+'&month='+bodyData.month+'&year='+bodyData.year,
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackJobReleased = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/jobs/?job_id='+bodyData.jobId+'&area_equipment_id='+bodyData.area_equipment_id,
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const getBackEnggList = (bodyData)=>{
  return serverCallOther({
    method: 'GET',
    url: 'cmms/jobs/'+bodyData.siteId +'/',
    accept:'application/json',
    contentType:'application/json',
  })
  .then(res => {
    if(res.status === 200){
      return res.data;
    }
  }).catch((err) => {
    var msg = err.response.data.errors;
    Swal.fire({
      icon: 'error',
      title: err.response.status,
      allowOutsideClick:false,
      text: msg,
    }).then((result) => {
      // if (result.isConfirmed) {
      //   window.location.reload();
      // }
    })
    // MySwal.fire('<p>Something went wrong, please try again<p>');
    console.log('err',err);
  });
}

export const updateMappingEquipments = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/equipments/'+bodyData.equipmentID+'/updatemap/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const updateMappingComponent = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/components/'+bodyData.componentID+'/updateequipmentcomponentmap/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const updateMappingTaskList = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/components/'+bodyData.componentID+'/updatecomponenttaskmap/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      if(msg === "A database error occurred. Please contact your system administrator. - ('42000', '[42000] [Microsoft][ODBC Driver 18 for SQL Server][SQL Server]Duplicate tasks are not allowed (50001) (SQLParamData)')"){
        msg ='Duplicate tasks are not allowed';
      }
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitArea = (bodyData) => {
  return serverCallOther({
    method: 'POST',
    url: 'cmms/area/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const updateSubmitArea = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/area/'+bodyData.AreaID,
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      if(res.status === 200){
          MySwal.fire('<p>Data has been updated successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitEquipment = (bodyData) => {
  return serverCallOther({
    method: 'POST',
    url: 'cmms/equipments/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const updateSubmitEquipment = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/equipments/'+bodyData.equipmentID,
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been updated successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitComponent = (bodyData) => {
  return serverCallOther({
    method: 'POST',
    url: 'cmms/components/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const updateSubmitComponent = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/components/'+bodyData.ComponentID+'/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been updated successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitScheduled = (bodyData) => {
  return serverCallOther({
    method: 'POST',
    url: 'cmms/jobs/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been added successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitReleased = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/jobs/'+bodyData.JobID+'/release/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been updated successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}

export const postSubmitSaved = (bodyData) => {
  return serverCallOther({
    method: 'PUT',
    url: 'cmms/jobs/'+bodyData.JobID+'/save/',
    data: bodyData,
    accept:'application/json',
    contentType:'application/json',
  }).then(res => {
      
      if(res.status === 200){
          MySwal.fire('<p>Data has been updated successfully<p>');
        return res.status;
        }else{
          MySwal.fire('<p>Something went wrong, please try again<p>');
        }
    }).catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: 'error',
        title: err.response.status,
        allowOutsideClick:false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      })
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log('err',err);
    });
}